import { Controller } from "@hotwired/stimulus"

// window.prompt() dell'originale prima di un invio (pages/Piani.js: «Chiudi» una richiesta, «Annota» la fattura).
// Sul pulsante che invia: ogni campo del suo form con `data-domanda` si chiede in ordine e prende la risposta; «Annulla»
// nel prompt non invia niente. `data-predefinito`: la risposta proposta; `data-oggi`: proposta la data di oggi
// (new Date().toISOString().slice(0, 10)); `data-obbligatorio`: anche una risposta vuota non invia (if (!numero) return).
// <button type="submit" form="…" data-controller="prompt" data-action="prompt#chiedi">
export default class extends Controller {
  chiedi(event) {
    const campi = this.element.form ? this.element.form.querySelectorAll("[data-domanda]") : []
    for (const campo of campi) {
      const proposta = campo.dataset.oggi !== undefined ? new Date().toISOString().slice(0, 10) : campo.dataset.predefinito
      const risposta = proposta === undefined ? window.prompt(campo.dataset.domanda) : window.prompt(campo.dataset.domanda, proposta)
      if (risposta === null || (campo.dataset.obbligatorio !== undefined && !risposta)) {
        event.preventDefault()
        return
      }
      campo.value = risposta
    }
  }
}
